export const timestampGenerator = () => Math.round(Date.now() / 1000);
//# sourceMappingURL=timestamps.js.map